import { PORTAL_ID } from '@/constants/hubspot';
import Script from 'next/script';

export const HubspotTrackingScript = (
  <Script
    src={`https://js.hs-scripts.com/${PORTAL_ID}.js`}
    id="hs-script-loader"
    data-hsjs-portal={PORTAL_ID}
    strategy="afterInteractive"
    type="text/javascript"
  />
);

export const HubspotInitScript = (
  // eslint-disable-next-line @next/next/no-before-interactive-script-outside-document
  <Script
    id="hubspot-init"
    strategy="beforeInteractive"
    dangerouslySetInnerHTML={{
      __html: `
        window._hsp = window._hsp || [];
        window._hsq = window._hsq || [];
      `,
    }}
  />
);
